import axios from 'axios';

export const uploadFiles = async (files: any[], folderId?: string) => {
  await axios.post(`/asset/file`, { files, folder: folderId });
};
